import { render, staticRenderFns } from "./ImagesResourceModal.vue?vue&type=template&id=3665db32&scoped=true&"
import script from "./ImagesResourceModal.vue?vue&type=script&lang=js&"
export * from "./ImagesResourceModal.vue?vue&type=script&lang=js&"
import style1 from "./ImagesResourceModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665db32",
  null
  
)

export default component.exports